
import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'
import CategoryHeader from './CategoryHeader.vue'
import CategoryMenuSection from './CategoryMenuSection.vue'
import CategoryList from './CategoryList.vue'
import MobileCategories from './MobileCategories.vue'
export default Vue.extend({
  name: 'AllCategories',
  components: {
    CategoryMenuSection,
    CategoryHeader,
    CategoryList,
    MobileCategories
  },
  props: {
     productCategories: {
      type: Array as () => ProductCategory[],
      required: true
    }
  },
  computed: {
    isDesktopView(): boolean {
      return window.innerWidth > 1024
    }
  }
})
